import api from '../api'
import {extractUserErrorMessage, extractValidationErrors} from '../../../../helpers/api'

import {
    ADD_SPECIALIST,
    CHANGE_PROGRESS,
    DELETE_CLIENT,
    DELETE_CLIENT_SPECIALIST,
    FULLFILL_CLIENT,
    FULLFILL_CLIENTS,
    FULLFILL_SPECIALIST,
    RESET_VALIDATION_ERRORS_BY_FIELD,
    SET_VALIDATION_ERRORS,
} from '../mutations/available'

import _ from 'lodash'
import NotificationService from '../../../../services/notificationService'

export const getAll = async ({state, dispatch, commit}) => {
    if (state.progress['getAllClients']) {
        return
    }

    commit(CHANGE_PROGRESS, {context: 'getAllClients', value: true})

    try {
        const clientsData = await api.getAll()
        commit(FULLFILL_CLIENTS, clientsData)
    } catch (e) {
        NotificationService.error(`Unable to get clients. Try again later`)
        console.log(`Unable to get clients, details: ${e.message}`)
    }

    commit(CHANGE_PROGRESS, {context: 'getAllClients', value: false})
}

export const createClient = async ({state, dispatch, commit}, clientData) => {
    if (state.progress['createClient']) {
        return
    }

    commit(CHANGE_PROGRESS, {context: 'createClient', value: true})
    commit(SET_VALIDATION_ERRORS, {
        context: 'createClient',
        value: {}
    })

    let created = false
    try {
        await api.createClient(clientData)
        NotificationService.success(`Client '${clientData.title} was successfully created'`)
        created = true
    } catch (e) {
        const validationErrors = extractValidationErrors(e)

        if (validationErrors) {
            commit(SET_VALIDATION_ERRORS, {
                context: 'createClient',
                value: validationErrors
            })
        } else {
            NotificationService.error(`Unable to create client. Try again later`)
        }
    }

    commit(CHANGE_PROGRESS, {context: 'createClient', value: false})

    return created
}

export const updateClient = async ({state, dispatch, commit}, clientData) => {
    if (state.progress['updateClient']) {
        return
    }

    commit(CHANGE_PROGRESS, {context: 'updateClient', value: true})
    commit(SET_VALIDATION_ERRORS, {
        context: 'updateClient',
        value: {}
    })

    let updated = false
    try {
        const updatedClient = await api.updateClient(clientData)
        commit(FULLFILL_CLIENT, updatedClient)
        updated = true
        NotificationService.success(`Client '${clientData.title}' was successfully updated`)
    } catch (e) {
        const validationErrors = extractValidationErrors(e)

        if (validationErrors) {
            commit(SET_VALIDATION_ERRORS, {
                context: 'updateClient',
                value: validationErrors
            })
        } else {
            NotificationService.error(`Unable to update client '${clientData.title}'. Try again later`)
        }
        console.log(`Unable to update client, details: ${e.message}`)
    }

    commit(CHANGE_PROGRESS, {context: 'updateClient', value: false})

    return updated
}

export const deleteClient = async ({state, dispatch, commit}, clientData) => {
    if (state.progress['deleteClient']) {
        return
    }

    commit(CHANGE_PROGRESS, {context: 'deleteClient', value: true})

    let result = false
    try {
        await api.deleteClient(clientData.id)
        commit(DELETE_CLIENT, clientData)
        NotificationService.success(`Client '${clientData.title}' was successfully deleted`)
        result = true
    } catch (e) {
        const defaultErrorMessage = `Unable to delete client '${clientData.title}'. Try again later`
        NotificationService.error(extractUserErrorMessage(e, defaultErrorMessage))
    }

    commit(CHANGE_PROGRESS, {context: 'deleteClient', value: false})

    return result
}

export const createClientSpecialist = async ({state, dispatch, commit}, clientSpecialistData) => {
    if (state.progress['createClientSpecialist']) {
        return
    }

    commit(CHANGE_PROGRESS, {context: 'createClientSpecialist', value: true})
    commit(SET_VALIDATION_ERRORS, {
        context: 'createClientSpecialist',
        value: {}
    })

    let created = false
    try {
        const createdSpecialist = await api.createClientSpecialist(clientSpecialistData)
        commit(ADD_SPECIALIST, createdSpecialist)
        NotificationService.success(`Embriologist '${clientSpecialistData.name}' was successfully created'`)
        created = true
    } catch (e) {
        const validationErrors = extractValidationErrors(e)

        if (validationErrors) {
            commit(SET_VALIDATION_ERRORS, {
                context: 'createClientSpecialist',
                value: validationErrors
            })
        } else {
            NotificationService.error(`Unable to create embriologist. Try again later`)
        }

        console.log(`Unable to create embriologist, details: ${e.message}`)
    }

    commit(CHANGE_PROGRESS, {context: 'createClientSpecialist', value: false})

    return created
}

export const updateClientSpecialist = async ({state, dispatch, commit}, clientSpecialistData) => {
    if (state.progress['updateClientSpecialist']) {
        return
    }

    commit(CHANGE_PROGRESS, {context: 'updateClientSpecialist', value: true})
    commit(SET_VALIDATION_ERRORS, {
        context: 'updateClientSpecialist',
        value: {}
    })

    let updated = false
    try {
        const updatedClientSpecialist = await api.updateClientSpecialist(clientSpecialistData)
        commit(FULLFILL_SPECIALIST, updatedClientSpecialist)
        updated = true
        NotificationService.success(`Embriologist '${updatedClientSpecialist.name}' was successfully updated`)
    } catch (e) {
        const validationErrors = extractValidationErrors(e)

        if (validationErrors) {
            commit(SET_VALIDATION_ERRORS, {
                context: 'updateClientSpecialist',
                value: validationErrors
            })
        } else {
            NotificationService.error(`Unable to update embriologist ${clientSpecialistData.title}. Try again later`)
        }

        console.log(`Unable to update embriologist, details: ${e.message}`)
    }

    commit(CHANGE_PROGRESS, {context: 'updateClientSpecialist', value: false})

    return updated
}

export const deleteClientSpecialist = async ({state, dispatch, commit}, clientSpecialistData) => {
    if (state.progress['deleteClientSpecialist']) {
        return
    }

    commit(CHANGE_PROGRESS, {context: 'deleteClientSpecialist', value: true})

    let deleted = false

    try {
        await api.deleteClientSpecialist(clientSpecialistData.id)
        deleted = true
        commit(DELETE_CLIENT_SPECIALIST, clientSpecialistData)
        NotificationService.success(`Embryologist '${clientSpecialistData.name}' was successfully deleted`)
    } catch (e) {
        const defaultErrorMessage = `Unable to delete embryologist '${clientSpecialistData.name}'. Try again later`
        NotificationService.error(extractUserErrorMessage(e, defaultErrorMessage))
    } finally {
        commit(CHANGE_PROGRESS, {context: 'deleteClientSpecialist', value: false})
    }

    return deleted
}

export const resetValidationErrorsByField = async ({state, commit}, {context, fieldName}) => {
    commit(RESET_VALIDATION_ERRORS_BY_FIELD, {context, fieldName})
}

export const afterApplicationInit = {
    root: true,
    async handler(namespacedContext, payload) {
        const clients = _.get(payload, 'clients', [])
        namespacedContext.commit(FULLFILL_CLIENTS, clients)
    }

}

